import { SecretKey } from './abstract/secret-key.entity';
import { Admin } from './admin.entity';
import { GybDevice } from './gyb-device.entity';
import { Reseller } from './reseller.entity';
import { Restaurant } from './restaurant.entity';
import { Staff } from './staff.entity';
import { Warrant } from './warrant.entity';

// *********************
// 敏感操作记录类型
// *********************
export class SensitiveRecord {

    // *********************
    // Key Info
    // *********************

    // 敏感操作记录id
    public _id?: string;
    // 操作员id
    public admin_id?: string;
    // 操作员名称
    public admin_nickname?: string;
    // 电话
    public phone?: string;
    // 电话号码前缀
    public phone_prefix?: string;
    // 操作人数组
    public operator?: Admin[];

    // *********************
    // Belonged
    // *********************

    // 操作的餐厅
    public belonged_restaurant?: Array<{
        // 餐厅id
        _id?: string;
        // 餐厅名称
        nickname?: string;
        // 餐厅标识码  string_id
        string_id?: string;
    }>;
    // 操作的集团
    public belonged_group?: Array<{
        // 集团id
        _id?: string;
        // 集团名称
        nickname?: string;
        // 集团标识码  string_id
        string_id?: string;
    }>;

    // *********************
    // Basic Info
    // *********************

    // 操作的时间
    public operation_time?: string;
    // 操作的类型
    public operation_type?: OperationType;
    // 授权点信息
    public warrants?: Array<Warrant>;
    // 开始时间
    public start_time?: string;
    // 结束时间
    public end_time?: string;


    // 操作的GYB数据 操作类型为GYB设备操作相关时才有数据  否则为null
    public gyb_device?: GybDevice | null;
    // 扩展功能密钥 操作类型为密钥相关时才有数据  否则为null
    public secret_key?: SecretKey | null;
    // 更换集团时产生的数据  操作类型为Replace_Group时才有数据  否则为null
    replace_group?: {
        // 更换到的目标集团名
        newGroupnickname?: string;
        // 更换到的目标集团标识码 string_id
        newGroupstring_id?: string;
        // 原集团名
        oldGroupnickname?: string;
        // 原集团标识码 string_id
        oldGroupstring_id?: string;
    };

    // 员工增删查的数据
    public details?: {
        // 绑定、解绑餐厅 员工详情
        staff?: Staff;
        // 绑定、解绑餐厅 餐厅详情
        restaurant?: Restaurant;
        // 修改密码、新增、删除staff时存
        staff_info?: Staff;
        // 修改员工信息时存
        new_staff_info?: Staff;
        origin_staff_info?: Staff;
        // 新增、删除reseller时存
        reseller_info?: Reseller;
        // 修改reseller时存
        new_reseller_info?: Reseller;
        origin_reseller_info?: Reseller;
        // 云分析数据来源变更的操作员 ID
        operator_id?: string;
        // 云分析数据来源变更的操作员账号类型
        operator_account_type?: string;
        // 云分析数据来源变更前的值
        previous_value?: string;
        // 云分析数据来源变更后的值
        new_value?: string;
        // 云分析数据来源是否实际发生变更
        changed?: boolean;
        // 触发云分析数据来源变更的请求路径
        request_path?: string;
    };

    // ip
    public machine_ip?: string;
}
/**
 * 敏感操作记录类型枚举值
 */
export enum OperationType {

    // *********************
    // 授权方案操作相关
    // *********************

    // 添加授权
    OP_ADD_WARRANT = 'ADD_WARRANT',
    // 删除授权
    OP_CANCEL_WARRANT = 'CANCEL_WARRANT',

    // *********************
    // GYB设备操作相关
    // *********************

    // 添加gyb设备
    OP_Add_GybDevice = 'Add_GybDevice',
    // 删除GYB设备
    OP_Delete_GybDevice = 'Delete_GybDevice',
    // GYB设备设置默认
    OP_Default_GybDevice = 'Default_GybDevice',

    // *********************
    // 扩展功能密钥操作相关
    // *********************

    // 添加密钥
    OP_Add_SecretKey = 'Add_SecretKey',
    // 刷新密钥
    OP_Refresh_SecretKey = 'Refresh_SecretKey',
    // 删除密钥
    OP_Delete_SecretKey = 'Delete_SecretKey',

    // *********************
    // 更换集团操作相关
    // *********************

    // 更换集团
    OP_Replace_Group = 'Replace_Group',

    // *********************
    // 员工增删改操作相关、解绑、绑定餐厅相关操作
    // *********************

    // 删除员工
    OP_Delete_Staff = 'Delete_Staff',
    // 新增员工
    OP_Add_Staff = 'Add_Staff',
    // 编辑员工
    OP_Update_Staff = 'Update_Staff',
    // 绑定餐厅
    OP_Bind_Restaurant = 'Bind_Restaurant',
    // 解绑餐厅
    OP_Unbind_Restaurant = 'Unbind_Restaurant',
    // 修改密码
    OP_Update_Password = 'Update_Password',

    // *********************
    // 经销商新增删除
    // *********************
    OP_Add_Reseller = 'Add_Reseller',
    OP_Delete_Reseller = 'Delete_Reseller',
    OP_Update_Reseller = 'Update_Reseller',
    // 修改云分析数据来源
    OP_Update_Cloud_Analysis_Origin = 'UPDATE_CLOUD_ANALYSIS_ORIGIN'
}